import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container
} from 'reactstrap';
import CloseIcon from '../../images/close-button-search.png';
import ImageSeller from '../../images/sellerlocation.png';
const conditionGuide = [
  {'name' : 'Brand New', 'detail':'Totally new and unused with complete inclusions.'},
  {'name' : 'Pristine', 'detail':'Very excellent condition with no visible signs of wear and defects.'},
  {'name' : 'Good', 'detail':'Well maintained condition with visible imperfections.'},
  {'name' : 'Well Used', 'detail':'Signs of wear and imperfections are clearly visible such as discoloration and scratches.'},
  {'name' : 'Like New', 'detail':'Never been worn or only once or twice with almost no signs of wear.'},
  {'name' : 'Vintage', 'detail':'The item is at least 20 years of age.'},
];
const ModalConditionGuide = props => {
  return (
    <Modal
      className="kick-modal condition-guide"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <Container id="condition">
        <div className="close-modal" onClick={props.onToggle}>
          <KickImage src={CloseIcon} alt="close-icon"/>
        </div>
        <div className="title-modal">
          <p>CONDITION GUIDE</p>
        </div>
        <ModalBody>
          <div className="condition-wrapper">
            {conditionGuide.map((value, index) => (
              <>
                <p className="condition-text">{value.name}</p>
                <p className="condition-detail">{value.detail}</p>
              </>
            ))}
          </div>     
        </ModalBody>
          <div className="footer-wrapper">
            <p className="condition-text">AUTHENTIC. GUARANTEED.</p>
            <p className="condition-detail">All purchased product will be thoroughly examined and matched with the listing condition.</p>
          </div>
      </Container>
    </Modal>
  )
}

export default ModalConditionGuide;